// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2mBMi","Body":"App_Body__2VISZ"};